import { SearchTagResults } from '../../../../types/mfc'

export const escapeRegExp = (stringToGoIntoTheRegex = '') => {
    return stringToGoIntoTheRegex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
}

export const sortStringMatches = (
    source: string,
    searchString = '',
    split = '  ',
) => {
    if (!source) return ''
    const sortedMatches = []

    source.split(split).forEach((tag) => {
        if (tag.match(new RegExp(searchString, 'i'))) {
            sortedMatches.unshift(tag)
        } else {
            sortedMatches.push(tag)
        }
    })

    return sortedMatches.join(' ')
}

interface SearchTags {
    [key: string]: {
        [key: string]: boolean
    }
}

export const getSearchResultTags = (
    searchString: string,
    users,
): Array<SearchTagResults> => {
    if (!Array.isArray(users?.data)) return []
    const searchTags: SearchTags = {}
    users?.data?.forEach((user) => {
        user?.tags?.split('  ').forEach((tag) => {
            if (tag.indexOf(searchString) !== -1) {
                if (!searchTags[tag]) searchTags[tag] = {}
                searchTags[tag][user.name] = true
            }
        })
    })

    const res: Array<SearchTagResults> = Array.from(
        Object.keys(searchTags)
            .map((tagName) => {
                return {
                    name: tagName,
                    count: Object.keys(searchTags[tagName]).length,
                }
            })
            .sort((a, b) => {
                if (a.count > b.count) return -1
                else return 1
            }),
    )
    return res
}
